module.exports = __webpack_public_path__ + "img/cd_man.747a8aea.jpg";